import { axiosSwagger } from "@/axios";


export const state = {
    categoryFile: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // CATEGORY
    loading: (state, loading) => {
        state.categoryFile.loading = loading;
    },
    setData: (state, data) => {
        state.categoryFile.data = data;
    },
    setTotal: (state, total) => {
        state.categoryFile.total = total;
    }
}


export const actions = {
    // READ CATEGORY FILES BY DELIVERY UNIT ID
    async readCategoryFilesByDeliveryUnitId({ commit }) {
        commit("loading", true);

        const userData = localStorage.getItem("USER") !== null && localStorage.getItem("USER") !== '' ? JSON.parse(localStorage.getItem("USER")) : null;

        return await axiosSwagger
        .get(`/api/FileManager/Category/Files/${userData?.deliveryUnit?.id}`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    }
}